import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { loginFailure, loginSuccess } from "../actions/loginAction";

function* asyncSubmitLoginRequestSaga(action){

    try{
    yield put(clearErrors());
    let loginResult = yield call(_api.submitLoginRequest,{
        loginReq: action.payload.loginReq
    })
     yield put(loginSuccess({loginResult}));
    }catch(e){
        yield put(loginFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* submitLoginRequestSaga(){
    yield takeLatest(types.LOGIN_REQUEST,asyncSubmitLoginRequestSaga)
}